import { render, staticRenderFns } from "./NcTable.vue?vue&type=template&id=c493ca52&scoped=true&"
import script from "./NcTable.vue?vue&type=script&lang=js&"
export * from "./NcTable.vue?vue&type=script&lang=js&"
import style0 from "./NcTable.vue?vue&type=style&index=0&id=c493ca52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493ca52",
  null
  
)

export default component.exports